<template>
	<v-card
		flat
		width="500px"
	>
		<v-card-title class="secondary--text">
			<span>Filtri</span>
			<v-spacer></v-spacer>
		</v-card-title>
		<v-card-text>
			<v-row v-if="!hideClientiFilter" class="mt-1">
				<v-col>
					<v-autocomplete
						v-model="computedClientiIds"
						:items="clienti"
						label="Clienti"
						:loading="isLoadingClienti"
						:disabled="isLoadingClienti"
						item-value="id"
						item-text="cognome_nome_ragione_sociale_tipologia"
						multiple
						small-chips
						clearable
						deletable-chips
						outlined
						dense
					></v-autocomplete>
				</v-col>
			</v-row>
			
			<v-row class="mt-0">
				<v-col>
					<v-autocomplete
						v-model="computedPraticaTagsIds"
						:items="tagsPratica"
						label="Tags Pratica"
						:loading="isLoadingTagsPratica"
						:disabled="isLoadingTagsPratica"
						item-value="id"
						item-text="text"
						multiple
						small-chips
						clearable
						deletable-chips
						outlined
						dense
					></v-autocomplete>
				</v-col>
			</v-row>
			
			<v-row class="mt-0">
				<v-col>
					<v-autocomplete
						v-model="computedContrattoDiServizioTagsIds"
						:items="tagsContrattoDiServizio"
						label="Tags Contratto di Servizio"
						:loading="isLoadingTagsContrattoDiServizio"
						:disabled="isLoadingTagsContrattoDiServizio"
						item-value="id"
						item-text="text"
						multiple
						small-chips
						clearable
						deletable-chips
						outlined
						dense
					></v-autocomplete>
				</v-col>
			</v-row>
			
			<v-row class="mt-0">
				<v-col>
					<v-select
						v-model="computedEsitoClickDay"
						:items="tipiEsitoClickday"
						label="Esito Click Day"
						clearable
						outlined
						dense
					></v-select>
				</v-col>
			</v-row>
			
			<v-row class="mt-0">
				<v-col>
					<v-autocomplete
						v-model="computedRegioni"
						:items="regioniItems"
						label="Regioni"
						multiple
						small-chips
						clearable
						deletable-chips
						outlined
						dense
					></v-autocomplete>
				</v-col>
			</v-row>
			
			<v-row class="mt-1">
				<v-col>
					<v-autocomplete
						v-model="computedAssiDiFinanziamento"
						:items="assiDiFinanziamentoItems"
						item-value="id"
						item-text="nome"
						label="Assi di Finanziamento"
						:loading="isLoadingAssiDiFinanziamento"
						:disabled="isLoadingAssiDiFinanziamento"
						multiple
						small-chips
						clearable
						deletable-chips
						outlined
						dense
					></v-autocomplete>
				</v-col>
			</v-row>
			
			<v-row class="mt-0">
				<v-col>
					<template v-for="(faseWithStati, index) in computedFasiWithStati">
						<v-select
							:value="idsStatiFasi[`id_stato_fase_${faseWithStati.ordinamento}`].valueNonApplied"
							@input="setIdStatoFase({ id: $event, ordinamento: faseWithStati.ordinamento })"
							:items="faseWithStati.stati"
							item-text="nome"
							item-value="id"
							:label="`Stato fase ${faseWithStati.ordinamento} - ${faseWithStati.nome}`"
							hide-details
							class="mb-3"
							clearable
							outlined
							dense
						></v-select>
					</template>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-btn
				@click="resetFilters()"
				color="info"
			>
				Azzera filtri
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn
				@click="closeDialog()"
				color="tertiary"
				class="black--text"
			>
				Annulla
			</v-btn>
			<v-btn
				@click="applyFilters()"
				color="secondary"
				:disabled="isLoading"
			>
				Filtra
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {eventBus} from "@/event-bus";
import {mapActions, mapGetters, mapMutations} from "vuex";
export default {
	props: {
		hideClientiFilter: {
			default: false
		},
		// accountManagersIds: {
		// 	default: null
		// }
	},
	data() {
		return {
			isLoadingClienti: false,
			clienti: [],
			
			isLoadingTagsPratica: false,
			tagsPratica: [],
			
			isLoadingTagsContrattoDiServizio: false,
			tagsContrattoDiServizio: [],
			
			isLoadingAssiDiFinanziamento: false,
			assiDiFinanziamentoItems: [],
		}
	},
	
	created() {
		if (!this.hideClientiFilter) this.getClienti();
		this.getTagsPratica();
		this.getTagsContrattoDiServizio();
		this.getAssiDiFinanziamento();
	},
	
	computed: {
		...mapGetters({
			fasiWithStati: 'fasi/fasiWithStati',
			clientiIds: 'praticheFilters/clientiIds',
			praticaTagsIds: 'praticheFilters/praticaTagsIds',
			contrattoDiServizioTagsIds: 'praticheFilters/contrattoDiServizioTagsIds',
			esitoClickDay: 'praticheFilters/esitoClickDay',
			regioni: 'praticheFilters/regioni',
			assiDiFinanziamentoIds: 'praticheFilters/assiDiFinanziamentoIds',
			idsStatiFasi: 'praticheFilters/idsStatiFasi',
			defaultFilters: 'praticheFilters/defaultFilters',
			bando: 'shared/bando'
		}),
		computedClientiIds: {
			get: function () {
				return this.clientiIds.value;
			},
			set: function (value) {
				if (value?.length === 0) value = null;
				this.setClientiIdsNotApplied(value);
			}
		},
		computedPraticaTagsIds: {
			get: function () {
				return this.praticaTagsIds.value;
			},
			set: function (value) {
				if (value?.length === 0) value = null;
				this.setPraticaTagsIdsNotApplied(value);
			}
		},
		computedContrattoDiServizioTagsIds: {
			get: function () {
				return this.contrattoDiServizioTagsIds.value;
			},
			set: function (value) {
				if (value?.length === 0) value = null;
				this.setContrattoDiServizioTagsIdsNotApplied(value);
			}
		},
		computedEsitoClickDay: {
			get: function () {
				return this.esitoClickDay.value;
			},
			set: function (value) {
				this.setEsitoClickDayNotApplied(value);
			}
		},
		computedRegioni: {
			get: function () {
				return this.regioni.value;
			},
			set: function (value) {
				this.setRegioniNotApplied(value);
			}
		},
		computedAssiDiFinanziamento: {
			get: function () {
				return this.assiDiFinanziamentoIds.value;
			},
			set: function (value) {
				this.setAssiDiFinanziamentoIdsNotApplied(value);
			}
		},
		isLoading() {
			return this.isLoadingClienti;
		},
		computedFasiWithStati() {
			let fasiWithStati = [];
			this.fasiWithStati.forEach(faseWithStati => {
				let fws = Object.assign({}, faseWithStati);
				fws.nome = fws.nome.replace('<br>', ' ');
				fasiWithStati.push(fws);
			});
			return fasiWithStati;
		}
	},
	
	methods: {
		...mapMutations({
			setClientiIdsNotApplied: 'praticheFilters/SET_CLIENTI_IDS_NON_APPLIED',
			setPraticaTagsIdsNotApplied: 'praticheFilters/SET_PRATICA_TAGS_IDS_NON_APPLIED',
			setContrattoDiServizioTagsIdsNotApplied: 'praticheFilters/SET_CONTRATTO_DI_SERVIZIO_TAGS_IDS_NON_APPLIED',
			setEsitoClickDayNotApplied: 'praticheFilters/SET_ESITO_CLICK_DAY_NON_APPLIED',
			setRegioniNotApplied: 'praticheFilters/SET_REGIONI_NON_APPLIED',
			setAssiDiFinanziamentoIdsNotApplied: 'praticheFilters/SET_ASSI_DI_FINANZIAMENTO_IDS_NON_APPLIED',
			setIdStatoFase: 'praticheFilters/SET_ID_STATO_FASE_NOT_APPLIED'
		}),
		...mapActions({
			applyFiltersAction: 'praticheFilters/applyFilters',
			resetFiltersAction: 'praticheFilters/resetFilters',
		}),
		getClienti() {
			this.isLoadingClienti = true;
			axios.get('/api/clienti', {
				params: {
					order_by: 'cognome'
				}
			})
				.then(response => {
					this.clienti = response.data;
				})
				.finally(() => {
					this.isLoadingClienti = false;
				})
		},
		getTagsPratica() {
			this.isLoadingTagsPratica = true;
			axios.get('/api/tags', {
				params: {
					type: 'pratica'
				}
			})
				.then(response => {
					this.tagsPratica = response.data;
				})
				.finally(() => {
					this.isLoadingTagsPratica = false;
				})
		},
		getTagsContrattoDiServizio() {
			this.isLoadingTagsContrattoDiServizio = true;
			axios.get('/api/tags', {
				params: {
					type: 'contratto_di_servizio'
				}
			})
				.then(response => {
					this.tagsContrattoDiServizio = response.data;
				})
				.finally(() => {
					this.isLoadingTagsContrattoDiServizio = false;
				})
		},
		getAssiDiFinanziamento() {
			this.isLoadingAssiDiFinanziamento = true;
			axios.get('/api/assi-di-finanziamento', {
				params: {
					bando_id: this.bando.id
				}
			})
				.then(response => {
					this.assiDiFinanziamentoItems = response.data;
				})
				.finally(() => {
					this.isLoadingAssiDiFinanziamento = false;
				})
		},
		applyFilters() {
			this.applyFiltersAction();
			this.$emit('reload-pratiche');
			this.closeDialog();
		},
		resetFilters(withoutApply = false) {
			this.resetFiltersAction();
			this.$emit('reload-pratiche');
			this.closeDialog();
		},
		closeDialog() {
			this.$emit('close');
		}
	}
}
</script>

<style scoped>

</style>